var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.btns),function(ref,index){
var text = ref[0];
var rounded = ref[1];
return _c('v-menu',{key:text,attrs:{"rounded":rounded,"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var attrs = ref.attrs;
var on = ref.on;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"text-capitalize",class:_vm.textColorClass,attrs:{"small":"","elevation":"0","light":"","color":_vm.menuColor},on:{"click":function($event){return _vm.goto('/')}}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("\n          home\n        ")]),_vm._v("\n        "+_vm._s(text)+"\n      ")],1)]}}],null,true)})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }